import { Component, Input, OnInit } from '@angular/core';
import { ProductVariant } from '../../interfaces/wheels';

@Component({
  selector: 'app-wheel-product-info',
  templateUrl: './wheel-product-info.component.html',
  styleUrls: ['./wheel-product-info.component.scss']
})
export class WheelProductInfoComponent implements OnInit {
  @Input() product: ProductVariant;
  @Input() deliveryDate: any;
  @Input() is_hide_cost: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Gets the product image URL or placeholder
   */
  getProductImage(): string {
    if (this.product?.images && this.product.images.length > 0) {
      return this.product.images[0];
    }
    return '/placeholder.png';
  }

  /**
   * Gets the product title
   */
  getProductTitle(): string {
    if (!this.product) return 'Product Name';
    
    const brand = this.product.brand?.name || '';
    const model = this.product.model?.name || '';
    const finish = this.product.finish?.finish || '';
    
    return `${brand} - ${model} ${finish} Wheel`.trim();
  }

  /**
   * Gets the formatted delivery date
   */
  getFormattedDeliveryDate(): string {
    if (!this.deliveryDate) return '';
    
    const date = new Date(this.deliveryDate);
    return date.toLocaleDateString('en-US', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  }

  /**
   * Checks if product has valid pricing information
   */
  hasPricing(): boolean {
    return !!(this.product?.uae_retail_price || this.product?.price);
  }

  /**
   * Gets the product SKU for display
   */
  getProductSku(): string {
    return this.product?.sku || 'N/A';
  }
}
